module.exports = __webpack_public_path__ + "img/3ALogo.813493c4.png";